const locale = 'nl-nl';
export const readableNumber = (inputValue, currency) => {
    const { value, order } = readableNumberParts(inputValue, currency);
    return order ? `${value} ${order}` : value;
};
export const readableNumberParts = (inputValue = 0, currency) => {
    const absValue = Math.abs(inputValue);
    const options = currency
        ? {
            currency,
            currencyDisplay: 'symbol',
            style: 'currency',
        }
        : {};
    const obj = (value, order) => ({
        number: inputValue,
        long: inputValue.toLocaleString(locale, options).replace(/,0+$/, ''),
        longDecimal: inputValue.toLocaleString(locale, options),
        value,
        order,
    });
    const toLocaleWithoutTrailingZero = (value) => {
        return value
            .toLocaleString(locale, options)
            .replace(/(,0+|(,[1-9]+)0*)$/, '$2');
    };
    if (absValue > 10_000_000) {
        return obj(toLocaleWithoutTrailingZero(Math.round(inputValue / 1_000_000)), 'miljoen');
    }
    if (absValue > 1_000_000) {
        return obj(toLocaleWithoutTrailingZero(Math.round(inputValue / 100_000) / 10), 'miljoen');
    }
    if (absValue > 10_000) {
        return obj(toLocaleWithoutTrailingZero(Math.round(inputValue / 1_000)), 'duizend');
    }
    if (absValue > 1_000) {
        return obj(toLocaleWithoutTrailingZero(Math.round(inputValue / 100) / 10), 'duizend');
    }
    return obj(inputValue.toLocaleString(locale, options));
};
